// 支付方式状态
const STATUS_ENABLE = 1 // 已启用
const STATUS_DISABLE = 2 // 已停用

const map = new Map([
  [STATUS_ENABLE, { mean: '已启用', type: 'success' }],
  [STATUS_DISABLE, { mean: '已停用', type: 'danger' }]
])

export default {
  map,
  STATUS_ENABLE,
  STATUS_DISABLE
}
